import * as React from 'react';
import { lastItem } from '../lib';
import { ServiceSchedule } from '../shared-types';
import { useLazyRef } from './use-lazy-ref';

export const useMonthRange = (schedules: ServiceSchedule[] | null) => {
  const lastMonthDate = React.useMemo(() => {
    const lastDate = new Date(
      schedules && schedules.length > 0 ? lastItem(schedules).date : ''
    );
    return new Date(lastDate.getFullYear(), lastDate.getMonth());
  }, [schedules]);
  const currentDateRef = useLazyRef(() => new Date());
  const currentMonthStartRef = useLazyRef(() => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth());
  });
  return {
    lastMonthDate,
    currentDateRef,
    currentMonthStartRef,
  };
};
